import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { tv } from 'tailwind-variants';

import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
} from '@/components/ui/dropdown';

import picture from './picture.png';

export type SitesDetailsHeroProps = {
  className?: string;
};

export function SitesDetailsHero({ className }: SitesDetailsHeroProps) {
  const style = sitesDetailsHeroStyle({ hasImage: true });

  return (
    <div className={style.container({ className })}>
      <img src={picture} alt="" className={style.img()} />
      <div className={style.bg()} />
      <div className={style.content()}>
        <div>
          <h1 className={style.name()}>SMA</h1>
        </div>
      </div>
      <div className={style.dropdown()}>
        <Dropdown>
          <DropdownButton variant="ghost" className={style.dropdownButton()}>
            <EllipsisHorizontalIcon className="size-6" />
          </DropdownButton>
          <DropdownMenu className={style.dropdownMenu()} />
        </Dropdown>
      </div>
    </div>
  );
}

export const sitesDetailsHeroStyle = tv({
  slots: {
    container: `
      group
      relative
      h-36
      w-full
      overflow-hidden
      rounded-t-md
      bg-gray-200
      shadow-inner
      lg:h-72
    `,
    img: `
      size-full
      object-cover
    `,
    bg: `
      absolute
      inset-0
      bg-gradient-to-t
      from-black/20
      to-transparent
    `,
    content: `
      absolute
      inset-x-0
      bottom-0
      grid
      grid-cols-2
      space-y-2
      p-6
      text-white
    `,
    contentRight: `
      flex
      items-end
      justify-self-end
    `,
    name: `
      text-3xl
      font-bold
      text-white
    `,
    address: `
      text-lg
      text-gray-100
    `,
    dropdown: `
      absolute
      right-4
      top-4
    `,
    dropdownButton: `
      bg-white/70
      p-1
      text-zinc-600
      opacity-50
      transition-opacity
      hover:bg-white
      hover:text-zinc-600
      group-hover:opacity-100
    `,
    dropdownMenu: `
      absolute
      right-0
      z-50
    `,
  },
  variants: {
    hasImage: {
      true: {
        dropdownButton: `
          opacity-0
          group-hover:opacity-50
        `,
      },
    },
  },
});
